import { type ReactNode } from 'react';
import { cn } from '@/lib/utils';

export type StatColor = 'blue' | 'green' | 'purple' | 'orange' | 'teal' | 'red' | 'yellow';

const colorStyles: Record<StatColor, string> = {
  blue:   'bg-blue-50 text-blue-600 dark:bg-blue-950/40 dark:text-blue-400',
  green:  'bg-green-50 text-green-600 dark:bg-green-950/40 dark:text-green-400',
  purple: 'bg-violet-50 text-violet-600 dark:bg-violet-950/40 dark:text-violet-400',
  orange: 'bg-orange-50 text-orange-500 dark:bg-orange-950/40 dark:text-orange-400',
  teal:   'bg-teal-50 text-teal-600 dark:bg-teal-950/40 dark:text-teal-400',
  red:    'bg-red-50 text-red-600 dark:bg-red-950/40 dark:text-red-400',
  yellow: 'bg-yellow-50 text-yellow-600 dark:bg-yellow-950/40 dark:text-yellow-400',
};

interface StatCardProps {
  icon: ReactNode;
  value: string | number;
  label: string;
  color?: StatColor;
  className?: string;
}

export function StatCard({ icon, value, label, color = 'blue', className }: StatCardProps) {
  return (
    <div className={cn('bg-card border border-border rounded-xl p-4 flex flex-col gap-3 hover:shadow-sm transition-shadow', className)}>
      <div className={cn('w-9 h-9 rounded-lg flex items-center justify-center flex-shrink-0', colorStyles[color])}>
        {icon}
      </div>
      <div>
        <div className="text-2xl font-bold text-foreground tracking-tight">{value}</div>
        <div className="text-sm text-muted-foreground mt-0.5">{label}</div>
      </div>
    </div>
  );
}
